export default class ForgotPassword {
  constructor() {
    this.email = ''
  }
}
